<template>
  <header class="header">
    <nav class="nav" >
      <ul class="nav-links" >
        <li class="link mt-6" >
          <router-link to="/" :style="{'color':getSecondaryColor}">
          <v-icon small left
          :style="{'color':getSecondaryColor}" >mdi-home</v-icon>Home</router-link>
        </li>
        <li class="link mt-6" >
          <router-link to="/web-store" :style="{'color':getSecondaryColor}">
          <v-icon small left
          :style="{'color':getSecondaryColor}" >mdi-store</v-icon>Store</router-link>
        </li>
        <li class="link mt-6" v-if="getAuthenticated">
          <router-link to="/switchboard" :style="{'color':getSecondaryColor}">
          <v-icon small left
          :style="{'color':getSecondaryColor}" >mdi-apps</v-icon>
          Switchboard</router-link>
        </li>
        <li class="link">
          
          <v-autocomplete
          dense
          label="Select Category"
          :color="getSecondaryColor"
          :items="['All Products','Phones','Notebooks']"
          :style="{'background-color':getSecondaryColor}"
          class="mt-6"
          >
          </v-autocomplete>
        
          
        </li>
      </ul>
    </nav>
    <slot></slot>
  </header>
</template>

<script>
export default {
  computed:{
    getSecondaryColor(){
      return this.$store.getters.getSecondaryColor
    },
    getAuthenticated() {
      return this.$store.getters.getAuthenticated;
    },
  }
};
</script>

<style scoped>
  .header {
    width: 100%;
    height: 70px;
    background-color: #333333;
    box-sizing: border-box;
    padding: .5em;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .nav {
    width: 600px;
  }

  .nav-links {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }

  .link {
    list-style: none;
    padding: 0 2em;
  }

  .link a {
    color: #fff;
    text-decoration: none;
  }
</style>
